import { render, staticRenderFns } from "./PlacasMae.vue?vue&type=template&id=7cbc95ca&"
import script from "./PlacasMae.vue?vue&type=script&lang=ts&"
export * from "./PlacasMae.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports